"use strict";var r=require("./Card.js");module.exports=r.Card;
